<template>
  <div class="w-100">
    <h1 class="mb-0 pb-3 px-3">
      {{ title }}
    </h1>
    <BProgress class="mx-3"
               height="3px"
               :max="max">
      <BProgressBar :value="value"
                    :variant="BootstrapVariant.PRIMARY"></BProgressBar>
    </BProgress>
  </div>
</template>

<script>
  import { BProgress, BProgressBar } from 'bootstrap-vue';
  import BootstrapVariant from '~/zf/frontend/vendor/bootstrap/BootstrapVariant';

  export default {
    name: 'ModalHeaderWithProgressBar',
    compatConfig: {
      MODE: 3,
    },
    components: {
      BProgress,
      BProgressBar,
    },
    props: {
      max: {
        required: true,
        type: Number,
      },
      title: {
        required: true,
        type: String,
      },
      value: {
        required: true,
        type: Number,
      },
    },
    data() {
      return {
        BootstrapVariant,
      };
    },
  };
</script>
